Object.defineProperty(exports,"__esModule",{value:true});exports.creators=exports.default=exports.actions=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _reduxOrm=require('redux-orm');
var _utils=require('./utils');function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var actions=exports.actions={
UPSERT_MANUFACTURER:'UPSERT_MANUFACTURER',
UPDATE_MANUFACTURERS:'UPDATE_MANUFACTURERS',
UPDATE_MANUFACTURER:'UPDATE_MANUFACTURER'};var





Manufacturer=function(_Model){_inherits(Manufacturer,_Model);function Manufacturer(){_classCallCheck(this,Manufacturer);return _possibleConstructorReturn(this,(Manufacturer.__proto__||Object.getPrototypeOf(Manufacturer)).apply(this,arguments));}_createClass(Manufacturer,[{key:'toString',value:function toString()



















































{
return'Manufacturer: '+this.id;
}}],[{key:'reducer',value:function reducer(action,Manufacturer,session){if(!action)return undefined;switch(action.type){case actions.UPSERT_MANUFACTURER:{var manufacturers=action.payload.manufacturers;manufacturers.forEach(function(m){Manufacturer.upsert(m);});break;}case actions.UPDATE_MANUFACTURERS:{var _manufacturers=action.payload.manufacturers;var manufacturersToRemove=Manufacturer.exclude(function(manufacturer){return _manufacturers.find(function(_ref){var id=_ref.id;return id===manufacturer.id;});});manufacturersToRemove.toModelArray().forEach(deleteRelatedChilds);manufacturersToRemove.delete();_manufacturers.forEach(function(manufacturer){var manufacturerExists=Manufacturer.hasId(manufacturer.id);if(manufacturerExists){var oldManufacturer=Manufacturer.withId(manufacturer.id);checkRelatedChildren(oldManufacturer,manufacturer);}Manufacturer.upsert(manufacturer);});break;}case actions.UPDATE_MANUFACTURER:{var manufacturer=action.payload.manufacturer;var manufacturerExists=Manufacturer.hasId(manufacturer.id);if(manufacturerExists){var oldManufacturer=Manufacturer.withId(manufacturer.id);checkRelatedChildren(oldManufacturer,manufacturer);}Manufacturer.upsert(manufacturer);break;}}return undefined;}}]);return Manufacturer;}(_reduxOrm.Model);exports.default=Manufacturer;

Manufacturer.modelName='Manufacturer';

Manufacturer.fields={
id:(0,_reduxOrm.attr)(),
name:(0,_reduxOrm.attr)(),
products:(0,_reduxOrm.attr)(),
securedProducts:(0,_reduxOrm.attr)()};


var upsertManufacturers=function upsertManufacturers(manufacturers){
var objs=manufacturers?
manufacturers.map(function(m){return(
(0,_utils.filterInput)(Manufacturer)(_extends({},
m,{
products:m.productByIds,
securedProducts:m.securedProductIds})));}):


[];

return{
type:actions.UPSERT_MANUFACTURER,
payload:{
manufacturers:objs}};


};

var updateManufacturers=function updateManufacturers(manufacturers){
var filteredManufacturers=manufacturers?
manufacturers.map(function(m){return(
(0,_utils.filterInput)(Manufacturer)(_extends({},
m,{
products:m.productByIds,
securedProducts:m.securedProductIds})));}):


[];
return{
type:actions.UPDATE_MANUFACTURERS,
payload:{
manufacturers:filteredManufacturers}};


};

var updateManufacturer=function updateManufacturer(manufacturer){
if(!manufacturer)return;

var filteredManufacturer=(0,_utils.filterInput)(Manufacturer)(_extends({},
manufacturer,{
products:manufacturer.productByIds,
securedProducts:manufacturer.securedProductIds}));

return{
type:actions.UPDATE_MANUFACTURER,
payload:{manufacturer:filteredManufacturer}};

};

var creators=exports.creators={
upsertManufacturers:upsertManufacturers,
updateManufacturers:updateManufacturers,
updateManufacturer:updateManufacturer};


var checkRelatedChildren=function checkRelatedChildren(oldManufacturer,newManufacturer){
checkRelationshipsToProductsAndDeleteOld(oldManufacturer,newManufacturer);
checkRelationshipsToSecuredProductsAndDeleteOld(
oldManufacturer,
newManufacturer);

};

var checkRelationshipsToProductsAndDeleteOld=function checkRelationshipsToProductsAndDeleteOld(
oldManufacturer,
newManufacturer)
{
var existingProducts=oldManufacturer.productByIds;
var newProducts=newManufacturer.products;

if(!existingProducts){
return;
}else if(!newProducts){
existingProducts.delete();
return;
}

existingProducts.
filter(function(product){return!newProducts.includes(product.id);}).
delete();
};

var checkRelationshipsToSecuredProductsAndDeleteOld=function checkRelationshipsToSecuredProductsAndDeleteOld(
oldManufacturer,
newManufacturer)
{
var existingProducts=oldManufacturer.securedProductIds;
var newProducts=newManufacturer.securedProducts;

if(!existingProducts){
return;
}else if(!newProducts){
existingProducts.delete();
return;
}

existingProducts.
filter(function(product){return!newProducts.includes(product.id);}).
delete();
};

var deleteRelatedChilds=function deleteRelatedChilds(manufacturer){
manufacturer.securedProductIds&&manufacturer.securedProductIds.delete();
manufacturer.productIds&&manufacturer.productIds.delete();
};